import { useFormik } from "formik";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import React, { Fragment, useRef } from "react";
import { useState } from "react";
import { FileUpload } from 'primereact/fileupload';
import moment from "moment";
import { contactService } from "../../../services/profile";
import { useEffect } from "react";
import { Util } from "../../../services";
import { classNames } from "primereact/utils";
import properties from "../../../config/environmentProperties";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { Tooltip } from "primereact/tooltip";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import UpdateMobileNoForm from "./updateMobileNoDialog";
import ContactDetailView from "./contact_detail_view";
import { userProfilePicture } from '../../../services/common/states';

function ContactInfo({ userProfilePhoto, user, contacts = [], onRefresh }) {
  const [showMessage, setShowMessage] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [country, setCountry] = useState(null);
  const [states, setStates] = useState(null);
  const [showNewForm, setShowNewForm] = useState(false);
  const [contactViewDialog, setContactViewDialog] = useState(false);
  const [showPhoneForm, setShowPhoneForm] = useState(false);
  const [editMobileData, setEditMobileData] = useState({});
  const [formData, setFormData] = useState({});
  const [editData, setEditData] = useState({});
  const [imagePath, setImagePath] = useState("");
  const [checked, setChecked] = useState(false);
  const [userPhoto, setUserPhoto] = useState(user?.photo);
  const [userPhone, setUserPhone] = useState(user?.phone);
  const imgPath = properties.currentEnvironment.docPath + "images/";

  const fileRef = useRef()

  useEffect(() => {
    get_contact(contacts);
  }, [])


  const uploadImage = async (e) => {
    var imgType = e.files[0].name.split(".")[1];
    if (imgType === "png" || imgType === "jpg" || imgType === "jpeg") {
      const file = e.files[0];
      const base64 = await Util.convertBase64(file);
      const reqBody = { photo: base64 };
      updateProfile(reqBody);
      fileRef?.current.clear();
    } else {
      fileRef?.current.clear();
      toast.error("Invalid file format");
    }
  };


  const updateProfile = (data) => {
    contactService.updateProfile(data).then((resp) => {
      const imageUrl = imgPath + resp.data.data.photo;
      setUserPhoto(resp.data.data.photo);
      userProfilePicture.next(resp?.data?.data?.photo);
      setImagePath(imageUrl);
    });
  };

  const getCountries = () => {
    contactService.getCountry().then((resp) => {
      setCountry(resp.data.data);
    });
  };

  const getStates = (countryId = {}) => {
    contactService.getAllState(countryId).then((resp) => {
      try {
        setStates(resp.data.states);
      } catch (error) { }
    });
  };

  const formik = useFormik({
    initialValues: {
      id: 0,
      alternateEmail: "",
      alternatePhone: "",
      permanentAddress: "",
      permanentAddress1: "",
      permanentCity: "",
      permanentState: "",
      permanentCountry: "",
      permanentPincode: "",
      currentAddress: "",
      currentAddress1: "",
      currentCity: "",
      currentState: "",
      currentCountry: "",
      currentPincode: ""
    },
    validate: (data) => {
      let errors = {};
      if (!data.alternateEmail) {
        errors.alternateEmail = "Alternate Email is required.";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.alternateEmail)
      ) {
        errors.alternateEmail = "Invalid email address. E.g. example@email.com";
      }
      if (!data.alternatePhone) {
        errors.alternatePhone = "Alternate phone no. is required.";
      } else if (
        !/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i.test(
          data.alternatePhone
        )
      ) {
        errors.alternatePhone = "Enter 10 digit phone no.";
      }
      if (!data.permanentAddress) {
        errors.permanentAddress = "Permanent address is required.";
      }
      if (!data.permanentAddress1) {
        errors.permanentAddress1 = "Permanent address1 is required.";
      }
      if (!data.permanentCity) {
        errors.permanentCity = "Permanent city is required.";
      }
      if (!data.permanentState) {
        errors.permanentState = "Permanent state is required.";
      }
      if (!data.permanentCountry) {
        errors.permanentCountry = "Permanent country is required.";
      }
      if (!data.permanentPincode) {
        errors.permanentPincode = "Permanent pincode is required.";
      }
      if (!data.currentAddress) {
        errors.currentAddress = "Current address is required.";
      }
      if (!data.currentAddress1) {
        errors.currentAddress1 = "Current address1 is required.";
      }
      if (!data.currentCity) {
        errors.currentCity = "Current city is required.";
      }
      if (!data.currentState) {
        errors.currentState = "Current state is required.";
      }
      if (!data.currentCountry) {
        errors.currentCountry = "Current country is required.";
      }
      if (!data.currentPincode) {
        errors.currentPincode = "Current pincode is required.";
      }
      return errors;
    },
    onSubmit: async (data) => {
      setFormData(data);
      setShowMessage(true);
      let dataObj = { ...data };
      // In case of data found
      if (contacts.length > 0) {
        dataObj = {
          id: editData.id,
          alternateEmail: data.alternateEmail,
          alternatePhone: data.alternatePhone,
          permanentAddress: data.permanentAddress,
          permanentAddress1: data.permanentAddress1,
          permanentCity: data.permanentCity,
          permanentState: data.permanentState.stateName,
          permanentCountry: data.permanentCountry.countryName,
          permanentPincode: data.permanentPincode,
          currentAddress: data.currentAddress,
          currentAddress1: data.currentAddress1,
          currentCity: data.currentCity,
          currentState: data.currentState.stateName,
          currentCountry: data.currentCountry.countryName,
          currentPincode: data.currentPincode,
        };
        await update_contact(dataObj);
      } else {
        dataObj = {
          alternateEmail: data.alternateEmail,
          alternatePhone: data.alternatePhone,
          permanentAddress: data.permanentAddress,
          permanentAddress1: data.permanentAddress1,
          permanentCity: data.permanentCity,
          permanentState: data.permanentState.stateName,
          permanentCountry: data.permanentCountry.countryName,
          permanentPincode: data.permanentPincode,
          currentAddress: data.currentAddress,
          currentAddress1: data.currentAddress1,
          currentCity: data.currentCity,
          currentState: data.currentState.stateName,
          currentCountry: data.currentCountry.countryName,
          currentPincode: data.currentPincode,
        };
        await add_contact(dataObj);
      }
      get_contact();
      onRefresh();
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const handleClearField = () => {
    formik.resetForm();
  };

  const clearForm = () => {
    setEditData({});
  };

  const clearMobileForm = () => {
    setEditMobileData({});
  };

  const createForm = () => {
    get_contact();
    getCountries();
    setShowNewForm(true);
  };

  const contactView = () => {
    setContactViewDialog(true);
  };

  const closeForm = () => {
    setShowNewForm(false);
  };

  const add_contact = (data) => {
    setShowNewForm(false);
    return new Promise((resolve) => {
      contactService.addContact(data).then((resp) => {
        resolve(resp);
      });
    });
  };

  const update_contact = (data) => {
    setShowNewForm(false);
    return new Promise((resolve) => {
      contactService.updateContact(data).then((resp) => {
        resolve(resp);
      });
    });
  };

  const updateMobileNo = (data) => {
    data = data.phone.replace(/-/g, "");
    var dataObj = {
      phone: data
    }
    localStorage.setItem('phone', dataObj.phone);
    contactService.updateProfile(dataObj).then((resp) => {
      setUserPhone(dataObj.phone);
      setShowPhoneForm(false);
    });
  };

  let count = 0;
  useEffect(() => {
    if (count === 0) {
      const imageUrl = imgPath + userProfilePhoto;
      setImagePath(imageUrl);
      count++;
    }
  }, [userProfilePhoto]);

  useEffect(() => {
    if (formik.values.permanentCountry && formik.values.permanentCountry.id) {
      getStates(formik.values.permanentCountry.id);
    }
  }, [formik.values.permanentCountry.id]);

  useEffect(() => {
    if (formik.values.currentCountry && formik.values.currentCountry.id) {
      getStates(formik.values.currentCountry.id);
    }
  }, [formik.values.currentCountry.id]);

  const fetchPermanentCountry = (data) => {
    contactService.getCountry().then((resp) => {
      resp.data.data.map((item) => {
        if (item.countryName === data.permanentCountry) {
          formik.setFieldValue("permanentCountry", item);
        }
      }
      )
    });
  }

  const fetchPermanentState = (data) => {
    contactService.getAllState(formik.values.permanentCountry.id).then((resp) => {
      resp.data.states.map((item) => {
        if (item.stateName === data.permanentState) {
          formik.setFieldValue("permanentState", item);
        }
      }
      )
    });
  }

  const fetchCurrentCountry = (data) => {
    contactService.getCountry().then((resp) => {
      resp.data.data.map((item) => {
        if (item.countryName === data.currentCountry) {
          formik.setFieldValue("currentCountry", item);
        }
      }
      )
    });
  }

  const fetchCurrentState = (data) => {
    contactService.getAllState(formik.values.currentCountry.id).then((resp) => {
      resp.data.states.map((item) => {
        if (item.stateName === data.currentState) {
          formik.setFieldValue("currentState", item);
        }
      }
      )
    });
  }

  const get_contact = () => {
    let data = contacts;
    setProfileData(data);
    if (data.length > 0) {
      setEditData(data[0]);
      formik.setFieldValue("alternateEmail", data[0].alternateEmail);
      formik.setFieldValue("alternatePhone", data[0].alternatePhone);
      formik.setFieldValue("permanentAddress", data[0].permanentAddress);
      formik.setFieldValue("permanentAddress1", data[0].permanentAddress1);
      formik.setFieldValue("permanentCity", data[0].permanentCity);
      fetchPermanentState(data[0]);
      fetchPermanentCountry(data[0]);
      formik.setFieldValue("permanentPincode", data[0].permanentPincode);
      formik.setFieldValue("currentAddress", data[0].currentAddress);
      formik.setFieldValue("currentAddress1", data[0].currentAddress1);
      formik.setFieldValue("currentCity", data[0].currentCity);
      fetchCurrentState(data[0]);
      fetchCurrentCountry(data[0]);
      formik.setFieldValue("currentPincode", data[0].currentPincode);
    }
  };

  const getValue = (e) => {
    setChecked(e.target.checked);
    if (e.target.checked) {
      formik.setFieldValue("currentAddress", formik.values.permanentAddress);
      formik.setFieldValue("currentAddress1", formik.values.permanentAddress1);
      formik.setFieldValue("currentCity", formik.values.permanentCity);
      formik.setFieldValue("currentState", formik.values.permanentState);
      formik.setFieldValue("currentCountry", formik.values.permanentCountry);
      formik.setFieldValue("currentPincode", formik.values.permanentPincode);
    } else {
      formik.setFieldValue("currentAddress", "");
      formik.setFieldValue("currentAddress1", "");
      formik.setFieldValue("currentCity", "");
      formik.setFieldValue("currentState", "");
      formik.setFieldValue("currentCountry", "");
      formik.setFieldValue("currentPincode", "");
    }
  };

  const ProfileEdit = () => {
    return (
      <div className="flex align-items-center flex-column px-3">
        <Dialog
          header={editData.id ? "Update Contact" : "New Contact"}
          visible={showNewForm}
          style={{ width: "500px" }}
          closeForm={() => setShowNewForm(false)}
          addHeading={(data) => add_contact(data)}
          editData={editData}
          updateHeading={(data) => update_contact(data)}
          clearForm={clearForm}
          country={country}
          onHide={() => { setShowNewForm(false); handleClearField(); }}
        >
          <form onSubmit={formik.handleSubmit} className="p-fluid p-grid contact_form">
            <div className="grid">
              <div className="p-field col-7">
                <span>
                  <label htmlFor="alternateEmail">Alternate Email:</label>
                  <InputText id="alternateEmail" name="alternateEmail" value={formik.values.alternateEmail} onChange={formik.handleChange} placeholder="Enter alternate email" className={classNames({ "p-invalid": isFormFieldValid("alternateEmail"), })} />
                </span>
                {getFormErrorMessage("alternateEmail")}
              </div>
              <div className="p-field col-5">
                <span>
                  <label htmlFor="alternatePhone"> Alternate Mobile Number: </label>
                  <InputMask id="alternatePhone" mask="999-999-9999" placeholder="999-999-9999" value={formik.values.alternatePhone} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("alternatePhone"), })}
                  />
                </span>
                {getFormErrorMessage("alternatePhone")}
              </div>
            </div>
            <div className="p-field">
              <span>
                <label htmlFor="permanentAddress">Permanent Address:</label>
                <InputTextarea id="permanentAddress" name="permanentAddress" autoResize value={formik.values.permanentAddress} onChange={formik.handleChange} placeholder="Enter permanent address" className={classNames({ "p-invalid": isFormFieldValid("permanentAddress"), })} />
              </span>
              {getFormErrorMessage("permanentAddress")}
            </div>
            <div className="p-field">
              <span>
                <label htmlFor="permanentAddress1">Permanent Address1:</label>
                <InputTextarea id="permanentAddress1" name="permanentAddress1" autoResize value={formik.values.permanentAddress1} onChange={formik.handleChange} placeholder="Enter permanent address1" className={classNames({ "p-invalid": isFormFieldValid("permanentAddress1"), })} />
              </span>
              {getFormErrorMessage("permanentAddress1")}
            </div>
            <div className="grid">
              <div className="p-field col-6">
                <span>
                  <label htmlFor="permanentCity">Permanent City:</label>
                  <InputText id="permanentCity" name="permanentCity" value={formik.values.permanentCity} onChange={formik.handleChange} placeholder="Enter permanent city" className={classNames({ "p-invalid": isFormFieldValid("permanentCity"), })} />
                </span>
                {getFormErrorMessage("permanentCity")}
              </div>
              <div className="p-field col-6">
                <span>
                  <label htmlFor="permanentCountry">Permanent Country:</label>
                  <Dropdown filter id="permanentCountry" name="permanentCountry" value={formik.values.permanentCountry} options={country} optionLabel="countryName" onChange={formik.handleChange} placeholder="Select a country" className={classNames({ "p-invalid": isFormFieldValid("permanentCountry"), })} />
                </span>
                {getFormErrorMessage("permanentCountry")}
              </div>
            </div>
            <div className="grid">
              <div className="p-field col-6">
                <span>
                  <label htmlFor="permanentState">Permanent State:</label>
                  <Dropdown id="permanentState" name="permanentState" options={states} value={formik.values.permanentState} onChange={formik.handleChange} optionLabel="stateName" placeholder="Select permanent state" className={classNames({ "p-invalid": isFormFieldValid("permanentState"), })} />
                </span>
                {getFormErrorMessage("permanentState")}
              </div>
              <div className="p-field col-6">
                <span>
                  <label htmlFor="permanentPincode">Permanent Pincode:</label>
                  <InputText id="permanentPincode" name="permanentPincode" value={formik.values.permanentPincode} onChange={formik.handleChange} placeholder="Enter permanent pincode" onKeyPress={Util.preventMinus} onPaste={Util.preventPasteChar} className={classNames({ "p-invalid": isFormFieldValid("permanentPincode"), })} />
                </span>
                {getFormErrorMessage("permanentPincode")}
              </div>
            </div>

            <div className="form-group">
              <Checkbox type="checkbox" id="checkbox" onChange={(e) => getValue(e)} checked={checked} />
              <label htmlFor="checkboxLabel"> Same as permanent address</label>
            </div>

            <div className="p-field">
              <span>
                <label htmlFor="currentAddress">Current Address:</label>
                <InputTextarea id="currentAddress" name="currentAddress" autoResize value={formik.values.currentAddress} onChange={formik.handleChange} placeholder="Enter current address" className={classNames({ "p-invalid": isFormFieldValid("currentAddress"), })} />
              </span>
              {getFormErrorMessage("currentAddress")}
            </div>
            <div className="p-field">
              <span>
                <label htmlFor="currentAddress1">Current Address1:</label>
                <InputTextarea id="currentAddress1" name="currentAddress1" autoResize value={formik.values.currentAddress1} onChange={formik.handleChange} placeholder="Enter current address1" className={classNames({ "p-invalid": isFormFieldValid("currentAddress1"), })}
                />
              </span>
              {getFormErrorMessage("currentAddress1")}
            </div>
            <div className="grid">
              <div className="p-field col-6">
                <span>
                  <label htmlFor="currentCity">Current City:</label>
                  <InputText id="currentCity" name="currentCity" value={formik.values.currentCity} onChange={formik.handleChange} placeholder="Enter current city" className={classNames({ "p-invalid": isFormFieldValid("currentCity"), })} />
                </span>
                {getFormErrorMessage("currentCity")}
              </div>
              <div className="p-field col-6">
                <span>
                  <label htmlFor="currentCountry">Current Country:</label>
                  <Dropdown filter id="currentCountry" name="currentCountry" value={formik.values.currentCountry} options={country} optionLabel="countryName" onChange={formik.handleChange} placeholder="Enter a country" className={classNames({ "p-invalid": isFormFieldValid("currentCountry"), })} onClick={() => clearForm()} />
                </span>
                {getFormErrorMessage("currentCountry")}
              </div>
            </div>
            <div className="grid">
              <div className="p-field col-6">
                <span>
                  <label htmlFor="currentState">Current State:</label>
                  <Dropdown id="currentState" name="currentState" options={states} value={formik.values.currentState} onChange={formik.handleChange} optionLabel="stateName" placeholder="Select current state" className={classNames({ "p-invalid": isFormFieldValid("currentState"), })} />
                </span>
                {getFormErrorMessage("currentState")}
              </div>
              <div className="p-field col-6">
                <span>
                  <label htmlFor="currentPincode">Current Pincode:</label>
                  <InputText id="currentPincode" name="currentPincode" value={formik.values.currentPincode} onChange={formik.handleChange} placeholder="Enter current pincode" onKeyPress={Util.preventMinus} onPaste={Util.preventPasteChar} className={classNames({ "p-invalid": isFormFieldValid("currentPincode"), })} />
                </span>
                {getFormErrorMessage("currentPincode")}
              </div>
            </div>
            
            <div className="grid mt-3">
              <div className="p-field col-12 text-right">
                <div className="">
                  <Button type="button" label="Cancel" onClick={() => { closeForm(); handleClearField(); }} className="p-button-rounded p-button-secondary" />
                  <Button type="submit" label="Save" className="p-button-rounded" />
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    );
  };

  const headerDialog = () => {
    return (
      <div className="grid">
        <span className="photo-span ml-1" style={{ height: "45px", width: "45px", borderRadius: "50%", border: "1px solid #ccc", background: "#1369b6", top: "16px", bottom: "16px", left: "16px", display: "block", textAlign: "center", fontSize: "30px", fontWeight: "600", color: "#fff" }}>
          {user.firstName.toUpperCase().substr(0, 1)}
          {user.lastName.toUpperCase().substr(0, 1)}
        </span>
        <div>
          <span className="capitalize ml-2">
            <strong style={{ fontSize: "19px", fontWeight: "500" }}>{user.firstName || ""} {user?.lastName || ""}</strong></span>{" "}
          <span style={{ fontSize: "15px", fontWeight: "500" }}>({user?.ecn || ""})</span><br />
          <small className="ml-2" style={{ fontWeight: "normal" }}>{user.email || ""}</small>
        </div>
      </div>
    )
  }

  const ContactInfoView = () => {
    return (
      <div className="flex align-items-center flex-column px-3">
        <Dialog header={headerDialog} visible={contactViewDialog} onHide={() => setContactViewDialog(false)} style={{ width: "450px" }}>
          <ContactDetailView closeForm={() => setContactViewDialog(false)} user={user} contacts={contacts} />
        </Dialog>
      </div>
    )
  }

  const MobileNoUpdateDialog = () => {
    return (
      <div className="flex align-items-center flex-column px-3">
        <Dialog header="Update mobile number" visible={showPhoneForm} onHide={() => setShowPhoneForm(false)} style={{ width: "380px" }}>
          <UpdateMobileNoForm editData={editMobileData} closeForm={() => setShowPhoneForm(false)} updateMobileNumber={(data) => updateMobileNo(data)} clearForm={clearMobileForm} user={user} /></Dialog>
      </div>
    )
  }

  function requestChangeNo(e) {
    e.preventDefault();
    setShowPhoneForm(true);
  }
  const chooseOptions = { label: 'Update', icon: 'pi pi-upload' };
  return (
    true ?
      <Fragment>
        {ProfileEdit()}
        {ContactInfoView()}
        {MobileNoUpdateDialog()}
        <div className="profile-card">
          <div className="grid">
            <div className="col profile-image-container" >
              {userProfilePhoto ? (<img src={imagePath} alt="" className="profile-image" style={{ border: '1px solid lightblue' }} />) : (
                <span className="profile-image-name">
                  {user.firstName.toUpperCase().substr(0, 1)}
                  {user.lastName.toUpperCase().substr(0, 1)}
                </span>
              )}
              <span className="profile-image-change">

                <FileUpload ref={fileRef} mode="basic" name="demo" accept="image/*" chooseOptions={chooseOptions} customUpload uploadHandler={(e) => uploadImage(e)} auto style={{ marginTop: '6px', marginRight: '9px' }} />

              </span>
            </div>

            <div className="col pl-4 profile-info-container">
              <div style={{ float: "right" }}>
                <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary" style={{borderRadius: "50%"}} onClick={() => contactView()} />
                <Button icon={contacts.length > 0 ? "pi pi-pencil" : "pi pi-plus"} className="p-button-rounded ml-1" style={{borderRadius: "50%" }} onClick={() => createForm()} />
              </div>

              <h5>
                {user.firstName || ""} {user?.lastName || ""}{" "}
                <small>( {user?.ecn || ""} )</small>
              </h5>

              <p>
                <b>Role : </b>
                <span style={{ textTransform: 'capitalize' }}>{user?.Designation?.title || ""}</span>{" "}
                {user?.Department === "" || user?.Department === null || user?.Department?.title === "" || user?.Department?.title === null ? '' : <span style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>({user?.Department?.title})</span>}
              </p>

              <p>
                <b>Date Of Joining : </b><span>{moment(user?.doj).format("DD-MM-YYYY") || ''}</span>
              </p>

              <p className="capitalize">
                <b>Reports to : </b><span style={{ textTransform: 'capitalize' }}>{user?.superior?.firstName || ""}{" "}{user?.superior?.lastName || ""}</span>{" "}
                {user?.superior?.Designation?.title === "" || user?.superior?.Designation?.title === null ? '' : <span style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>({user?.superior?.Designation?.title})</span>}
              </p>

              <p>
                  <b className='capitalize'>
                      Background Verification :
                  </b>
                  <span style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>({(user?.background_verification && user?.bgv_comment === 'Closed') ? 'Verified' : (user?.background_verification && user?.bgv_comment === 'Pending Verification') ? '---' : 'Verification Pending'})</span>
              </p>

              <p className="capitalize">
                <b>Location : <span style={{ textTransform: 'capitalize' }}>{user?.LegalEntity?.code}</span>{" "}{user?.location_type === "" || user?.location_type === null ? '' : <span>({user?.location_type})</span>}</b>
              </p>

              <p className="links">
                {userPhone ?
                  <span>
                    <i className="pi pi-phone" />
                    <a href={localStorage.getItem('phone') ? localStorage.getItem('phone') : userPhone || ""} onClick={requestChangeNo}>
                      {localStorage.getItem('phone') ? localStorage.getItem('phone') : userPhone || ""}
                    </a>{" "}
                    <i className="custom-tooltip-btn pi pi-info-circle" />
                    <Tooltip target=".custom-tooltip-btn" position="top">
                      <label>Update your mobile number</label>
                    </Tooltip>
                  </span> : ""}

                <span>
                  <i className="pi pi-envelope" />
                  {user.email || ""}
                </span>
              </p>
            </div>
          </div>
        </div>
      </Fragment> : <div>loading</div>

  );
}

export default ContactInfo;